<script>
import { BSidebar } from "bootstrap-vue";

export default {
  extends: BSidebar
};
</script>